module.exports = __webpack_public_path__ + "media/images/lb/258-603c718985bcffbc8aed4e53447f142c.svg";